import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { apiInstance } from "./axiosApi";
import authHeader from "./authHeader";
const getDefaultUser = () => {
  let user = localStorage.getItem("user");
  if (user && user !== "undefined") {
    return JSON.parse(user);
  } else {
    return null;
  }
};
const getDefaultUser1 = () => {
  let user1 = localStorage.getItem("user1");
  if (user1 && user1 !== "undefined") {
    return JSON.parse(user1);
  } else {
    return null;
  }
};
const getDefaultUser2 = () => {
  let user2 = localStorage.getItem("user2");
  if (user2 && user2 !== "undefined") {
    return JSON.parse(user2);
  } else {
    return null;
  }
};
const initialState = {
  user: localStorage.getItem("user") ? getDefaultUser() : {},
  user1: localStorage.getItem("user1") ? getDefaultUser1() : {},
  user2: localStorage.getItem("user2") ? getDefaultUser2() : {},
};

export const login = createAsyncThunk(
  "auth/login",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("/auth/login", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message);
    }
  }
);

export const verifyOtp = createAsyncThunk(
  "auth/verifyOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("/auth/otp/verify", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message);
    }
  }
);
export const changePassword = createAsyncThunk(
  "auth/changePassword",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "/auth/change-password",
        payload,
        {
          headers: authHeader(),
        }
      );
      return response;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message);
    }
  }
);

export const forgotPassword = createAsyncThunk(
  "auth/forgotPassword",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("/auth/forgot-password", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || "Forgot password failed!");
    }
  }
);
export const resetPassword = createAsyncThunk(
  "auth/resetPassword",
  async (payload) => {
    return await apiInstance.post("/auth/reset-password", payload);
  }
);
export const profileChange = createAsyncThunk(
  "auth/profileChange",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("/classes/edit", payload, {
        headers: authHeader(),
      });
      return response;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message);
    }
  }
);
export const getSingleClasses = createAsyncThunk(
  "auth/singleClasses",
  async (classesId, { rejectWithValue }) => { 
    try {
      const response = await apiInstance.get(`/classes/${classesId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    logOut: (state) => {
      state.user = {};
      state.user1 = {};
      state.user2 = {};
      localStorage.clear();
    },
    clearUser: (state) => {
      state.user = {};
      state.user1 = {};
      state.user2 = {};
      localStorage.removeItem("user");
      localStorage.removeItem("user1");
      localStorage.removeItem("user2");
    },
  },
  extraReducers: (builder) => {
    builder.addCase(login.fulfilled, (state, action) => {
      state.user = action.payload.data;
    });
    builder.addCase(verifyOtp.fulfilled, (state, action) => {
      state.user1 = action.payload.data;
    });
    builder.addCase(profileChange.fulfilled, (state, action) => {
        state.profileLoading = false;
        state.user = { ...state.user, ...action.payload.data };
        localStorage.setItem("user", JSON.stringify(state.user));
      })
    builder.addCase(resetPassword.fulfilled, (state, action) => {
      state.user2 = action.payload.data;
      const resetUser = action.payload.data;
      state.user = { ...state.user, ...resetUser };
    });
    builder.addCase(getSingleClasses.fulfilled, (state, action) => {
      state.singleClassesData = action.payload.data;
    });
  },
});

export default authSlice.reducer;
export const { logOut, clearUser } = authSlice.actions;

export const selectUser = (state) => {
  return state.auth.user;
};

export const useUser = () => {
  const user = useSelector(selectUser);
  localStorage.setItem("user", user ? JSON.stringify(user) : undefined);
  return useMemo(() => ({ user }), [user]);
};
export const selectUser1 = (state) => {
  return state.auth.user1;
};

export const useUser1 = () => {
  const user1 = useSelector(selectUser1);
  localStorage.setItem("user1", user1 ? JSON.stringify(user1) : undefined);
  return useMemo(() => ({ user1 }), [user1]);
};
export const selectUser2 = (state) => {
  return state.auth.user2;
};

export const useUser2 = () => {
  const user2 = useSelector(selectUser2);
  localStorage.setItem("user2", user2 ? JSON.stringify(user2) : undefined);
  return useMemo(() => ({ user2 }), [user2]);
};
